(() => {
  const root = document.querySelector('[data-bbs-partner-root]');
  if (!root || root.dataset.bbsPartnerInitialized) return;
  root.dataset.bbsPartnerInitialized = '1';
  const sb = window.supabase?.createClient(root.dataset.supabaseUrl, root.dataset.supabaseKey);
  if (!sb) return;

  const $ = s => root.querySelector(s);
  const authCard = $('[data-bbs-auth-card]'), dashboard = $('[data-bbs-dashboard]'), authStatus = $('[data-bbs-auth-status]'), importStatus = $('[data-bbs-import-status]');
  let membership = null, towns = [], destinationId = null, selectedFile = null;

  $('[data-bbs-auth-form]').addEventListener('submit', async e => {
    e.preventDefault(); authStatus.textContent = 'Sending secure sign-in link…';
    const email = $('[data-bbs-email]').value.trim();
    const { error } = await sb.auth.signInWithOtp({ email, options: { emailRedirectTo: window.location.href } });
    authStatus.textContent = error ? error.message : 'Check your email and open the sign-in link.';
  });

  $('[data-bbs-signout]').onclick = async () => { await sb.auth.signOut(); window.location.reload(); };
  $('[data-bbs-csv]').onchange = e => { selectedFile = e.target.files?.[0] || null; updateImportButton(); };
  $('[data-bbs-rights]').onchange = updateImportButton;
  $('[data-bbs-import]').onclick = importCsv;

  function updateImportButton(){ $('[data-bbs-import]').disabled = !selectedFile || !$('[data-bbs-rights]').checked || !membership || !['owner','manager'].includes(membership.role); }

  async function boot() {
    const { data: { session } } = await sb.auth.getSession();
    if (!session) return;
    const { data: memberships, error } = await sb.from('bbs_partner_memberships').select('company_id,role,bbs_rental_companies(name,slug)').eq('active', true).limit(1);
    if (error || !memberships?.length) {
      authStatus.textContent = 'This account is signed in, but it does not have a Beach by Street partner membership yet.';
      return;
    }
    membership = memberships[0];
    const [{ data: townData }, { data: dest }] = await Promise.all([
      sb.from('bbs_towns').select('id,name,slug').eq('active', true),
      sb.from('bbs_destinations').select('id').eq('slug','outer-banks').single()
    ]);
    towns = townData || []; destinationId = dest?.id || null;
    authCard.hidden = true; dashboard.hidden = false;
    $('[data-bbs-company]').textContent = membership.bbs_rental_companies?.name || 'Rental company';
    $('[data-bbs-role]').textContent = membership.role;
    await refreshDashboard(); updateImportButton();
  }

  async function refreshDashboard() {
    const cid = membership.company_id;
    const [{ count: propertyCount, data: props }, { count: clickCount }, { count: importCount }] = await Promise.all([
      sb.from('bbs_properties').select('id,address_line1,town_id,sleeps,price_from,active,updated_at', { count:'exact' }).eq('rental_company_id', cid).order('updated_at', { ascending:false }).limit(50),
      sb.from('bbs_referral_clicks').select('id', { count:'exact', head:true }).eq('rental_company_id', cid),
      sb.from('bbs_import_jobs').select('id', { count:'exact', head:true }).eq('company_id', cid)
    ]);
    $('[data-bbs-stat-properties]').textContent = propertyCount || 0;
    $('[data-bbs-stat-clicks]').textContent = clickCount || 0;
    $('[data-bbs-stat-imports]').textContent = importCount || 0;
    const townMap = new Map(towns.map(t => [t.id,t.name]));
    $('[data-bbs-property-rows]').innerHTML = (props || []).map(p => `<tr><td>${esc(p.address_line1)}</td><td>${esc(townMap.get(p.town_id) || '—')}</td><td>${p.sleeps ?? '—'}</td><td>${p.price_from ? '$'+Number(p.price_from).toLocaleString() : '—'}</td><td><span class="bbs-status-pill ${p.active?'is-live':''}">${p.active?'Live':'Hidden'}</span></td></tr>`).join('') || '<tr><td colspan="5">No properties imported yet.</td></tr>';
  }

  async function importCsv() {
    if (!selectedFile || !membership || !destinationId) return;
    importStatus.textContent = 'Reading CSV…';
    const text = await selectedFile.text(); const rows = parseCsv(text);
    if (!rows.length) { importStatus.textContent = 'The CSV contains no property rows.'; return; }
    const { data: { user } } = await sb.auth.getUser();
    const { data: job, error: jobErr } = await sb.from('bbs_import_jobs').insert({ company_id: membership.company_id, created_by: user.id, source_type:'csv', source_name:selectedFile.name, status:'running', rows_seen:rows.length }).select('id').single();
    if (jobErr) { importStatus.textContent = jobErr.message; return; }

    let created = 0, updated = 0, failed = 0; const errors = [];
    for (let i=0;i<rows.length;i++) {
      const r = rows[i]; importStatus.textContent = `Importing ${i+1} of ${rows.length}…`;
      const town = resolveTown(r.town); const required = ['external_id','address_line1','street_name','latitude','longitude','booking_url'];
      const missing = required.filter(k => !String(r[k] || '').trim());
      if (!town || missing.length) { failed++; errors.push(`Row ${i+2}: ${!town?'unknown town; ':''}${missing.length?'missing '+missing.join(', '):''}`); continue; }
      const payload = {
        external_id:r.external_id.trim(), rental_company_id:membership.company_id, destination_id:destinationId, town_id:town.id,
        property_name:nullish(r.property_name), address_line1:r.address_line1.trim(), street_name:r.street_name.trim(), street_number:nullish(r.street_number), postal_code:nullish(r.postal_code),
        latitude:num(r.latitude), longitude:num(r.longitude), bedrooms:intOrNull(r.bedrooms), bathrooms:numOrNull(r.bathrooms), sleeps:intOrNull(r.sleeps), description:nullish(r.description),
        hero_image_url:nullish(r.hero_image_url), booking_url:r.booking_url.trim(), price_from:numOrNull(r.price_from), price_unit:nullish(r.price_unit)||'week', ocean_distance_yards:intOrNull(r.ocean_distance_yards),
        beach_access:nullish(r.beach_access), pet_friendly:bool(r.pet_friendly), pool:bool(r.pool), hot_tub:bool(r.hot_tub), elevator:bool(r.elevator), oceanfront:bool(r.oceanfront), featured:bool(r.featured), active:r.active===''?true:bool(r.active), last_synced_at:new Date().toISOString(), updated_at:new Date().toISOString()
      };
      if (!Number.isFinite(payload.latitude) || !Number.isFinite(payload.longitude)) { failed++; errors.push(`Row ${i+2}: invalid latitude/longitude`); continue; }
      const { data: existing } = await sb.from('bbs_properties').select('id').eq('rental_company_id',membership.company_id).eq('external_id',payload.external_id).maybeSingle();
      const { data: prop, error } = await sb.from('bbs_properties').upsert(payload,{onConflict:'rental_company_id,external_id'}).select('id').single();
      if (error) { failed++; errors.push(`Row ${i+2}: ${error.message}`); continue; }
      existing ? updated++ : created++;

      if (r.gallery_urls?.trim()) {
        const urls = r.gallery_urls.split('|').map(x=>x.trim()).filter(Boolean);
        await sb.from('bbs_property_photos').delete().eq('property_id',prop.id);
        if (urls.length) await sb.from('bbs_property_photos').insert(urls.map((u,idx)=>({property_id:prop.id,image_url:u,sort_order:idx,licensed_or_authorized:true})));
      }
      if (r.availability_start && r.availability_end) {
        await sb.from('bbs_property_availability').upsert({ property_id:prop.id,start_date:r.availability_start,end_date:r.availability_end,available:true,price:numOrNull(r.availability_price),source_updated_at:new Date().toISOString() },{onConflict:'property_id,start_date,end_date'});
      }
    }
    const summary = errors.slice(0,8).join(' | ');
    await sb.from('bbs_import_jobs').update({status:failed && failed===rows.length?'failed':'complete',rows_created:created,rows_updated:updated,rows_failed:failed,error_summary:summary||null,completed_at:new Date().toISOString()}).eq('id',job.id);
    importStatus.textContent = `Import complete: ${created} created, ${updated} updated, ${failed} failed.${errors.length?' '+errors.slice(0,3).join(' | '):''}`;
    await refreshDashboard();
  }

  function resolveTown(v=''){ const q=String(v).trim().toLowerCase(); return towns.find(t=>t.slug===slugify(q)||t.name.toLowerCase()===q); }
  function slugify(v=''){return String(v).toLowerCase().trim().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');}
  function bool(v){return ['1','true','yes','y','on'].includes(String(v||'').trim().toLowerCase());}
  function num(v){return Number(String(v).replace(/[$,]/g,''));}
  function numOrNull(v){if(v===undefined||v===null||String(v).trim()==='')return null; const n=num(v); return Number.isFinite(n)?n:null;}
  function intOrNull(v){const n=numOrNull(v); return n===null?null:Math.round(n);}
  function nullish(v){return v===undefined||v===null||String(v).trim()===''?null:String(v).trim();}
  function esc(v=''){return String(v).replace(/[&<>'"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));}

  function parseCsv(text) {
    const lines=[]; let row=[], field='', quoted=false;
    for(let i=0;i<text.length;i++){
      const c=text[i], n=text[i+1];
      if(c==='"'&&quoted&&n==='"'){field+='"';i++;continue;}
      if(c==='"'){quoted=!quoted;continue;}
      if(c===','&&!quoted){row.push(field);field='';continue;}
      if((c==='\n'||c==='\r')&&!quoted){if(c==='\r'&&n==='\n')i++;row.push(field);field='';if(row.some(x=>x.trim()!==''))lines.push(row);row=[];continue;}
      field+=c;
    }
    if(field.length||row.length){row.push(field);if(row.some(x=>x.trim()!==''))lines.push(row);}
    if(lines.length<2)return[]; const headers=lines[0].map(h=>h.trim().toLowerCase());
    return lines.slice(1).map(cols=>Object.fromEntries(headers.map((h,i)=>[h,(cols[i]??'').trim()])));
  }
  boot();
})();
